var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("AddToCartController",
    ["$rootScope", "$scope", "$window", '$document', "cartService",
        function ($rootScope, $scope, $window, $document, cartService) {

            if (angular.isUndefined($rootScope.isDuplicateRequest)) {
                $rootScope.isDuplicateRequest = true;
            }

            function getCart(updateCart) {
                updateCart = angular.isDefined(updateCart) ? updateCart : false;
                if (updateCart) {
                    addToCart($scope.currentPrdId, true);
                }
            }

            $scope.addToCart = function (productId, isCheckout, selectedVarId, quantity, isBuyAllSizes, definitionName) {
                quantity = angular.isDefined(quantity) ? quantity : 1;
                isBuyAllSizes = angular.isDefined(isBuyAllSizes) ? isBuyAllSizes : false;                
                selectedVarId = angular.isDefined(selectedVarId) ? selectedVarId : "1";
                definitionName = angular.isDefined(definitionName) ? definitionName : "";
                var itemIdToAdd = "";
                if (selectedVarId != "1") {
                    itemIdToAdd = productId + "_var_" + selectedVarId;
                }
                addToCart(productId, isCheckout, itemIdToAdd, quantity, isBuyAllSizes, definitionName);
            }

            // #region Adding to cart from URL - Event will be emitted from product controller
            $rootScope.$on("AddToCart", function (evt, data) {
                if (data) {
                    if (!$rootScope.customerCartRS) {
                        $scope.currentPrdId = data.productId;
                        getCart(true);
                    }
                    else {
                        addToCart(data.productId, data.isCheckout);
                    }
                }
            });
            //#endregion

            //#region Function to Add Item To Cart
            function addToCart(productId, isCheckout, itemIdToAdd, quantity, isBuyAllSizes, definitionName) {
                itemIdToAdd = itemIdToAdd == "" ? productId : itemIdToAdd;
                quantity= angular.isDefined(quantity) ? quantity : 1;
                isBuyAllSizes = angular.isDefined(isBuyAllSizes) ? Boolean(isBuyAllSizes) : false;
                definitionName = angular.isDefined(definitionName) ? definitionName : "";
                isCheckout = (angular.isDefined(isCheckout) && isCheckout.toString().toLowerCase() == 'true') ? isCheckout : false;

                function getAddToCartButton() {
                    if (!productId) {
                        return $document[0].querySelector(".ss-hero-cart-btn, .btn-add-to-cart");
                    }
                    var byId = $document[0].getElementById("btn_" + productId)
                        || $document[0].getElementById("btn_" + String(productId).toLowerCase());
                    return byId || $document[0].querySelector(".ss-hero-cart-btn, .btn-add-to-cart");
                }

                function setLoading(isLoading) {
                    var btn = getAddToCartButton();
                    if (!btn || !btn.classList) {
                        return;
                    }
                    if (isLoading) {
                        btn.classList.add("loading");
                    } else {
                        btn.classList.remove("loading");
                    }
                }

                if ($rootScope.customerCartRS && $rootScope.customerCartRS.indexOf(itemIdToAdd) == -1) {
                    setLoading(true);
                    if (!isBuyAllSizes) {
                    return cartService.addLineItem(itemIdToAdd, quantity).then(function (response) {
                        if (response && response.data && response.data.itemAdded) {
                            this.productAdded = true;
                            $rootScope.$broadcast('CustomerCartChanged');
                            if ($rootScope.isCartPage) {
                                location.reload();
                            } else {
                                $rootScope.$broadcast('AddToCartSuccessFromPDP', productId);
                            }
                        }
                        else {
                            alert("Cart has reached Max Limit. Please checkout before adding any more new item's.");
                        }
                        setLoading(false);
                    });
                }
                else {
                    return cartService.addAllVariantsAsLineItems(itemIdToAdd, quantity, definitionName).then(function (response) {
                        if (response && response.data && response.data.itemAdded) {
                            this.productAdded = true;
                            $rootScope.$broadcast('CustomerCartChanged');
                            if ($rootScope.isCartPage) {
                                location.reload();
                            } else {
                                $rootScope.$broadcast('AddToCartSuccessFromPDP', productId);
                            }
                        }
                        else {
                            alert("Cart has reached Max Limit. Please checkout before adding any more new item's.");
                        }
                        setLoading(false);
                    });
                }
                }
                else if (isCheckout) {
                    $window.location.href = "/cart";
                }
                else {
                    alert("Item is already in cart");
                }
            }
            // #endregion

            // #region Check Item is already in Cart
            $scope.isItemInCart = function (prodId, variantId) {
                var itemInCart = false;
                var itemId = prodId + (variantId != "1" ? "_var_" + variantId : "");
                if ($rootScope.customerCartRS != null && $rootScope.customerCartRS.length > 0) {
                    if ($rootScope.customerCartRS.indexOf(itemId) != -1) {
                        itemInCart = true;
                    }
                }
                return itemInCart;
            }
            // #endregion
        }
    ]);
